import styles from './loader.module.css';

export const Loader = () => (
  <span role={'status'} data-testid={'loader'} className={styles['loader']} />
);
